import { useAuth } from '../../context/AuthContext';
import { useMenu } from '../../context/MenuContext';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const { user, logout } = useAuth();
  const { toggleMenu, isMenuOpen } = useMenu();
  const navigate = useNavigate();

  const handleLogout = async () => {
    console.log('Iniciando logout...');
    try {
      await logout();
      console.log('Logout realizado com sucesso, redirecionando...');
      navigate('/login');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
      navigate('/login');
    }
  };

  return (
    <header className="bg-white border-b border-neutral-200 px-6 py-4 shadow-soft w-full">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-6">
          {/* Botão de toggle do menu */}
          <button
            onClick={toggleMenu}
            className="p-2.5 rounded-xl hover:bg-neutral-100 transition-all duration-200 hover:shadow-soft"
            aria-label={isMenuOpen ? 'Recolher menu' : 'Expandir menu'}
            title={isMenuOpen ? 'Recolher menu' : 'Expandir menu'}
          >
            <svg
              className="w-6 h-6 text-neutral-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>
        
        {/* Lado direito do header */}
        <div className="flex items-center space-x-4">

          {/* Perfil do usuário */}
          <div className="flex items-center space-x-3">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-semibold text-neutral-900">
                {user?.fullName || 'Usuário'}
              </p>
              <p className="text-xs text-neutral-600">
                {user?.email || 'usuario@email.com'}
              </p>
            </div>
            
            {/* Avatar do usuário */}
            <div className="w-10 h-10 bg-coffee-gradient rounded-full flex items-center justify-center shadow-coffee">
              <span className="text-white text-sm font-bold">
                {user?.fullName?.charAt(0) || 'U'}
              </span>
            </div>

            {/* Dropdown do usuário */}
            <div className="relative group">
              <button className="p-1.5 rounded-lg hover:bg-neutral-100 transition-all duration-200">
                <svg className="w-4 h-4 text-neutral-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {/* Menu dropdown */}
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl shadow-large border border-neutral-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                <div className="py-2">
                  {/* <button className="w-full px-4 py-2 text-left text-sm text-neutral-700 hover:bg-neutral-50 transition-colors duration-200">
                    Meu Perfil
                  </button>
                  <button className="w-full px-4 py-2 text-left text-sm text-neutral-700 hover:bg-neutral-50 transition-colors duration-200">
                    Configurações
                  </button> */}
                  <hr className="my-2 border-neutral-200" />
                  <button 
                    onClick={handleLogout}
                    className="w-full px-4 py-2 text-left text-sm text-error-600 hover:bg-error-50 transition-colors duration-200"
                  >
                    Sair
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 